import axios from 'axios';

// Same-origin '/api' works out of the box in production since server.js
// serves this built frontend itself. Override only for local split dev.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('sungresh_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('sungresh_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
